jQuery('.examples-of-work-images-container').slick({
  dots: true,
  infinite: true,
  slidesToShow: 3, // Default to 3 images per row on desktop
  arrows: true,
  autoplay: true,
  responsive: [
      {
          breakpoint: 768,
          settings: {
              slidesToShow: 2, // 2 images per row on mobile
              arrows: true
          }
      }
  ]
});